// removed by extract-text-webpack-plugin
module.exports = {"more-options":"ContactMoreOptions__more-options___1Ocx4"};